import React from "react";
import { Switch, Route } from "react-router-dom";
import "./Employee.scss";

import EmployeesPage from "./EmployeesPage";
import EmployeePage from "./EmployeePage";
import NewEmployeePage from "./NewEmployeePage";

const EmployeeRouter = () => (
  <Switch>
    <Route path="/hr/employees/new">
      <NewEmployeePage />
    </Route>
    <Route path="/hr/employees/:id">
      <EmployeePage />
    </Route>
    <Route path="/hr/employees">
      <EmployeesPage />
    </Route>
  </Switch>
);

export default EmployeeRouter;
